import React from 'react';
import { Provider } from 'exoflex';
import { ApolloProvider } from '@apollo/react-hooks';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import { FONTS, THEME } from './constants/themes';
import { client } from './graphql/client';
import { routes } from './routes/routesPath';

export default function App() {
  return (
    <ApolloProvider client={client}>
      <Provider useSystemFonts={false} fonts={FONTS} theme={THEME}>
        <Router>
          <Switch>
            {routes.map((route, i) => (
              <Route key={i} strict={true} exact={true} {...route} />
            ))}
          </Switch>
        </Router>
      </Provider>
    </ApolloProvider>
  );
}
